import React, {Component, Fragment} from 'react';
import { Button, FormGroup, Input, Label, ListGroupItem } from 'reactstrap';

class TPPhaseFormForm extends Component {
  constructor(props) {
    super(props);
    this.titleMap = {
      dor: 'DOR',
      eop: 'EOP',
      wor: 'WOR',
      ftc: 'FTC'
    };
  }
  // ----------------------
  // Methods
  // ----------------------

  handleChange(event) {
    const { value } = event.target;
    this.props.onUpdateForm(value);
  }

  render() {
    return (
      <div className="training-phase-form-item">
        <FormGroup>
          <Label for="form">{this.titleMap[this.props.form.key]} Minimum Quantity *</Label>
          <Input
            id="form"
            name="form"
            onChange={event => this.handleChange(event)}
            type="select"
            value={this.props.form.min}
          >
            <option value={1}>1</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={4}>4</option>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
          </Input>
        </FormGroup>
        <button type="button" className="button delete small" onClick={() => this.props.onRemoveForm()}>
          <i className="fa fa-trash" />
          <span>Remove</span>
        </button>
      </div>
    );
  }
}

export default TPPhaseFormForm;
